<template>
  <transition-group name="fade" mode="out-in">
    <logout-modal
      key="logout-modal"
      v-if="showLogoutModal"
      @back="showLogoutModal = false"
    />
    <settings-modal
      key="settings-modal"
      v-else-if="showSettingsModal"
      @close="showSettingsModal = false"
    />
    <leave-warn-modal
      key="leave-warn-modal"
      v-else-if="showWarnModal"
      :prev-route="warnModalRoute"
      @back="showWarnModal = false"
    />
    <permission-denied-alert key="permission-denied-alert" />
    <role-change-modal
      key="role-change-modal"
      v-if="showRoleChangeModal"
      @close="showRoleChangeModal = false"
    />
  </transition-group>
</template>

<script>
import LogoutModal from "Public/components/GlobalModals/LogoutModal";
import SettingsModal from "Public/components/GlobalModals/SettingsModal";
import LeaveWarnModal from "Public/components/GlobalModals/LeaveWarnModal";
import {
  GLOBAL_EVENT_CREATE_LEAVE_WARNING,
  GLOBAL_EVENT_LOGOUT,
  GLOBAL_EVENT_SHOW_ROLE_CHANGE_MODAL,
  GLOBAL_EVENT_SHOW_SETTINGS,
} from "Consts/globalEvents";
import PermissionDeniedAlert from "Public/components/GlobalModals/PermissionDeniedAlert";
import AppUpdatedAlert from "Public/components/GlobalModals/AppUpdatedAlert";
import RoleChangeModal from "Views/Authorization/components/RoleChangeModal/index.vue";
export default {
  name: "GlobalModals",
  components: {
    RoleChangeModal,
    AppUpdatedAlert,
    PermissionDeniedAlert,
    LeaveWarnModal,
    SettingsModal,
    LogoutModal,
  },
  data() {
    return {
      showRoleChangeModal: false,
      showLogoutModal: false,
      showSettingsModal: false,
      showWarnModal: false,
      showJoinInfoModal: false,
      joinInfoModal: {
        show: false,
        linkedUsers: [],
        id: 0,
        type: 0,
      },
      warnModalRoute: {},
      showUpdateAlert: false,
    };
  },
  methods: {
    showRoleChange() {
      this.showRoleChangeModal = true;
    },
    showLogout() {
      this.showLogoutModal = true;
    },
    showSettings() {
      this.showSettingsModal = true;
    },
    handleLeaveCreate(route) {
      this.showWarnModal = true;
      this.warnModalRoute = Object.assign({}, route);
    },
  },
  created() {
    this.$root.$on(GLOBAL_EVENT_SHOW_ROLE_CHANGE_MODAL, this.showRoleChange);
    this.$root.$on(GLOBAL_EVENT_LOGOUT, this.showLogout);
    this.$root.$on(GLOBAL_EVENT_SHOW_SETTINGS, this.showSettings);
    this.$root.$on(GLOBAL_EVENT_CREATE_LEAVE_WARNING, this.handleLeaveCreate);
  },
  beforeDestroy() {
    this.$root.$off(GLOBAL_EVENT_SHOW_ROLE_CHANGE_MODAL, this.showRoleChange);
    this.$root.$off(GLOBAL_EVENT_LOGOUT, this.showLogout);
    this.$root.$off(GLOBAL_EVENT_SHOW_SETTINGS, this.showSettings);
    this.$root.$off(GLOBAL_EVENT_CREATE_LEAVE_WARNING, this.handleLeaveCreate);
  },
};
</script>

<style scoped></style>
